export default __webpack_public_path__ + "static/dotnetDev-6d78c5ae461f4f7c7cdbf4b781e15083.jpg";